import hash from 'object-hash';

const SALT = 'super-special-price-yanolja';

/**
 * generateHashedId
 * - 입력 문자열을 고유한 해시 ID로 변환합니다.
 * - 동일한 입력 문자열은 항상 동일한 해시 값을 반환합니다.
 * - 반환되는 해시의 길이를 조정할 수 있습니다.
 *
 * @param input - 해시로 변환할 입력 문자열
 * @param length - 반환할 해시 ID의 길이 (기본값: 6)
 * @returns - 변환된 고유 해시 ID
 */
export const generateHashedId = (input: string, length = 6): string => {
  const fullHash = hash({ input, salt: SALT });
  return fullHash.slice(0, length);
};
